import { FileText } from "lucide-react";
import { CommercialDownloadButton } from "./DownloadButton";

/**
 * Master v5 Prompt 14 — programme/package summary. Read-only card for
 * everyone; the coach's own editing form lives in CoachManagementPanel.
 */
export function PackageCard({ workspaceId, pkg }) {
  if (!pkg) {
    return (
      <div className="border border-ink/10 rounded-lg p-4 bg-paper" data-testid="commercial-package-empty">
        <p className="text-sm text-ink-soft italic">No programme/package has been set up yet.</p>
      </div>
    );
  }
  return (
    <div className="border border-ink/10 rounded-lg p-4 bg-paper" data-testid="commercial-package-card">
      <h2 className="font-serif text-lg text-ink mb-1">{pkg.title}</h2>
      {pkg.description && <p className="text-sm text-ink-soft mb-2">{pkg.description}</p>}
      <div className="flex items-center justify-between">
        <p className="text-sm text-ink">
          {pkg.price_amount != null && (
            <span className="font-medium">{pkg.price_currency} {pkg.price_amount.toLocaleString()}</span>
          )}
          {pkg.billing_cadence && <span className="text-ink-soft"> · {pkg.billing_cadence}</span>}
        </p>
        {pkg.programme_document_fas_id && (
          <CommercialDownloadButton
            workspaceId={workspaceId} fasId={pkg.programme_document_fas_id}
            label="Programme document" testId="commercial-package-download-btn"
          />
        )}
      </div>
      {!pkg.programme_document_fas_id && (
        <p className="text-xs text-ink-soft italic mt-2 flex items-center gap-1"><FileText size={12} /> No programme document uploaded yet.</p>
      )}
    </div>
  );
}
